// extracted by mini-css-extract-plugin
export default {"ingredient_bar":"IngredientBarBasic_ingredient_bar__Ty1Hu"};